import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    visible: false,
    searchValue: ""
};

const searchSlice = createSlice({
    name: "search",
    initialState,
    reducers: {
        toggleSearchVisible: (state, action) => {
            if (typeof action.payload === "boolean") {
                state.visible = action.payload;
            } else {
                state.visible = !state.visible;
            }
        },
        setSearchValue: (state, action) => {
            state.searchValue = action.payload;
        }
    }
});

export const { toggleSearchVisible, setSearchValue } = searchSlice.actions;
export default searchSlice.reducer;